import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/main.css'

import * as VueGoogleMaps from 'vue2-google-maps'
import VueApexCharts from 'vue-apexcharts'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import { faHome, faSignOutAlt, faCoffee, faChild, faCircle, faArchive, 
         faUserSecret, faExternalLinkAlt, faCheck, faTimes, faPlay } from '@fortawesome/free-solid-svg-icons'
import { faComment, faLightbulb, faEye, faThumbsUp, faThumbsDown } from '@fortawesome/free-regular-svg-icons'
import { faFacebook, faTwitter, faLinkedin, faYoutube } from '@fortawesome/free-brands-svg-icons'

library.add(
  faHome,
  faSignOutAlt,
  faCoffee,
  faChild,
  faCircle,
  faArchive,
  faComment,
  faFacebook,
  faTwitter,
  faLinkedin,
  faYoutube,
  faExternalLinkAlt,
  faLightbulb,
  faCheck,
  faTimes,
  faEye,
  faThumbsUp,
  faThumbsDown,
  faPlay
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

Vue.component('apexchart', VueApexCharts)

Vue.use(ElementUI);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCGUx8JyRs9h1KWy6ugUAhRaZFsT9kSvgk',
    libraries: 'places,drawing,visualization',
    region: 'SW',
    language: 'SV'
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
